import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Slash } from 'lucide-react';

import { PolicyTransactionsTable } from './table';

export function GeoveraPolicyTransactions() {
	const id = window.location.pathname.split('/').pop();
	const fileIngestionId = id ? parseInt(id) : NaN;
	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/geovera/policies">Policy Feed</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>Policy Transactions</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Policy Transactions</CardTitle>
					</span>
					<CardDescription>File Id {fileIngestionId}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<PolicyTransactionsTable fileIngestionId={fileIngestionId} />
				</CardContent>
			</Card>
		</>
	);
}
